module.exports = __webpack_public_path__ + "static/img/application.ea89609.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneCasePage/application.png
// module id = WJ8W
// module chunks = 0